<template>
    <v-flex
        md12
        class="px-12 pb-12"
    >
        <PageHeader
            :breadcrumbs="breadcrumbs"
            :title="pageTitle"
            back
            back-to="email_master_template"
        />
        <v-row>
            <v-col cols="12">
                <v-alert
                    v-for="(error, errorKey) in generalFormErrors"
                    :key="errorKey"
                    type="error"
                    v-text="error"
                />
                <EmailMasterTemplateForm
                    :data="data"
                    :raw-data="rawData"
                    :errors="formErrors"
                    :loading="loading"
                    :save-function="saveObject"
                    :discard-function="resetObject"
                />
            </v-col>
        </v-row>
    </v-flex>
</template>

<script>

import PageHeader from '@/components/common/PageHeader';
import EmailMasterTemplateForm from '@/components/emailMasterTemplate/Form/EmailMasterTemplateForm';
import EmailMasterTemplateProxy from '@/proxies/EmailMasterTemplateProxy';
import EmailMasterTemplateMixin from '@/mixins/emailmastertemplate';
import { SuccessSnackbar, StandBy } from '@/app-events.js';

export default {
    name: 'EmailMasterTemplateDetail',
    mixins: [ EmailMasterTemplateMixin ],
    components: {
        PageHeader,
        EmailMasterTemplateForm,
    },
    created() {
        this.fetchData();
    },
    data() {
        return {
            loading: false,
            data: {},
            rawData: {},
        };
    },
    computed: {
        pageTitle() {
            let title = this.data.name + ' ' + ('de' === this.data.language ? String.fromCodePoint(0x1F1E9, 0x1F1EA) : ('en' === this.data.language ? String.fromCodePoint(0x1F1EC, 0x1F1E7) : this.data.language));
            return title;
        },
        breadcrumbs() {
            return [
                {
                    text: this.$t('page.home.title'),
                    exact: true,
                    to: { name: 'home' },
                },
                {
                    text: this.$t('page.email_master_template.title'),
                    exact: true,
                    to: { name: 'email_master_template' },
                },
                {
                    text: this.data.emailType,
                    disabled: true,
                },
            ];
        },
    },
    methods: {
        fetchData() {
            this.loading = true;
            new EmailMasterTemplateProxy().find(this.$route.params.type, this.$route.params.language).then(({ data }) => {
                this.data = this.prepareData(data.data);
                this.rawData = JSON.parse(JSON.stringify(this.data));
                this.loading = false;
            }).catch(({ data }) => {
                this.displayError(data);
            });

        },
        saveObject() {
            this.$eventBus.dispatch(new StandBy(true));
            new EmailMasterTemplateProxy().update(this.$route.params.type, this.$route.params.language, this.prepareFormData(this.data)).then(({ data }) => {
                this.$eventBus.dispatch(new StandBy(false));
                this.rawData = JSON.parse(JSON.stringify(this.data));
                this.$eventBus.dispatch(new SuccessSnackbar(this.$t('email_master_template.actions.saved')));
                this.resetErrors();
            }).catch(({ data }) => {
                this.processErrors(data);
                this.$eventBus.dispatch(new StandBy(false));
            });
        },
    },
};
</script>
